import Modal from '../../../../shared/Modal'
import Button from '../../../../shared/Buttons/Button'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import promosApi from '../../promos.api'
import { IPromo } from '../../promos.types'
import TextField from '../../../../shared/Forms/TextField'
import TextInput from '../../../../shared/Inputs/TextInput'
import useStateWithChange from '../../../../shared/hooks/useStateWithChange'
import Textarea from '../../../../shared/Inputs/Textarea'
import PlanSelect from '../PlanSelect'
import NumberInput from '../../../../shared/Inputs/NumberInput'
import css from './createPromo.module.css'
import cn from '../../../../shared/cn'

interface IProps {
  onClose: () => void
  onSuccess: (created: IPromo) => void
}

const CreatePromoModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [dto, _, handleChange] = useStateWithChange<
    Pick<IPromo, 'title' | 'description' | 'discount' | 'code' | 'plan' | 'expired'>
  >({ title: '', description: '', code: '', plan: '', discount: 0.2, expired: plusSevenDays().toISOString() })

  const handleCreate = () => {
    wait(promosApi.createPromo(dto), (resp) => {
      if (resp.status === 'success') {
        props.onSuccess(resp.body)
      }
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className={cn('flex-form', css.wrapper)}>
        <h2 style={{ fontSize: 28 }}>Создание промокода</h2>
        <p style={{ marginBottom: '1em' }}>*Срок действия промокода 7 суток с момента создания.</p>
        <TextField header="Ссылка на блоггера / акцию">
          <TextInput value={dto.title} name="title" onChange={handleChange} placeHolder="https://..." />
        </TextField>
        <TextField header="Описание (можно указать стоимость)">
          <Textarea value={dto.description} name="description" onChange={handleChange} placeHolder="..." />
        </TextField>
        <TextField header="Код">
          <TextInput value={dto.code} name="code" onChange={handleChange} placeHolder="MAMA" />
        </TextField>
        <TextField header="План">
          <PlanSelect plan={dto.plan} name="plan" onChange={handleChange} autoSelect="ONE_TIME" />
        </TextField>
        <TextField header="Скидка в доле (0.2 = 20%, 0.35 = 35% итд)">
          <NumberInput value={dto.discount} onChange={handleChange} name="discount" />
        </TextField>
        <div className="form-footer">
          <Button onClick={handleCreate} loading={loading}>
            Сохранить
          </Button>
          <Button onClick={props.onClose}>Отмена</Button>
        </div>
      </div>
    </Modal>
  )
}

const plusSevenDays = () => new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7)

export default CreatePromoModal
